import { useEffect } from "react";
import PropTypes from "prop-types";
// eslint-disable-next-line import/no-extraneous-dependencies
import { useLocation } from "react-router";

const ScrollToTop = function ({ children }) {
  const { pathname } = useLocation();
  useEffect(() => {
    document.querySelector(".App").scrollTo(0, 0);
  }, [pathname]);

  return <>{children}</>;
};

ScrollToTop.propTypes = {
  children: PropTypes.node.isRequired,
};

export default ScrollToTop;
